import { Divider, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { ExitToApp, People, Store } from '@material-ui/icons';
import React from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

import packageJson from '../../../package.json';
import { useOrganization } from '../../context/OrganizationContext';
import { useUser } from '../../context/UserContext';
import { logoutService } from '../../services/customerService';
import { ACCOUNTS, STORES, CARTS, USERS, LOGIN } from '../../settings/constants';

import { DrawerContent, DrawerHeader, NavigationDrawer } from './styles';

type Props = {
	open: boolean;
	close: (...args: any[]) => any;
	variant: "permanent" | "persistent" | "temporary" | undefined;
};

const Drawer = ({ open, close, variant }: Props) => {
	const history = useHistory();
	const location = useLocation();
	const { url } = useRouteMatch();
	const { setUser } = useUser();

	const { organization } = useOrganization();

	const logout = async () => {
		await logoutService();
		setUser(null);
		history.push(`${LOGIN}`);
	};

	const goToCustomersPage = () => {
		history.push(`${url}${USERS}`);
	};

	const goToAccountsPage = () => {
		history.push(`${url}${ACCOUNTS}`);
	};

	const goToStoresPage = () => {
		history.push(`${url}${STORES}`);
	};

	const goToCartsPage = () => {
		history.push(`${url}${CARTS}`);
	};

	const items = [
		{
			label: 'Usuários',
			onClick: goToCustomersPage,
			selected: location.pathname.includes(USERS),
			icon: <People />,
		},
		{
			label: 'Contas',
			onClick: goToAccountsPage,
			selected: location.pathname.includes(ACCOUNTS),
			icon: <People />,
		},
		{
			label: 'Lojas',
			onClick: goToStoresPage,
			selected: location.pathname.includes(STORES),
			icon: <Store />,
		},
		{
			label: 'Carrinhos',
			onClick: goToCartsPage,
			selected: location.pathname.includes(CARTS),
			icon: <Store />,
		},
	];

	return (
		<NavigationDrawer variant={variant} open={open} onClose={close}>
			<DrawerHeader>
				<img src={organization.imgUri} alt="logo" style={{ width: '100px' }} />
				<Typography variant="caption" component="span" color="textSecondary">
					{packageJson.version} - {process.env.REACT_APP_PUBLIC_ENV}
				</Typography>
			</DrawerHeader>
			<Divider />
			<DrawerContent>
				<div tabIndex={0} role="button" onClick={close} onKeyDown={close}>
					<List>
						{items.map(item => (
							<ListItem key={item.label} button onClick={item.onClick} selected={item.selected}>
								<ListItemIcon>{item.icon}</ListItemIcon>
								<ListItemText>{item.label}</ListItemText>
							</ListItem>
						))}
					</List>
					<Divider />

					<List>
						<ListItem button onClick={logout} selected={false}>
							<ListItemIcon>
								<ExitToApp />
							</ListItemIcon>
							<ListItemText>Logout</ListItemText>
						</ListItem>
					</List>
				</div>
			</DrawerContent>
		</NavigationDrawer>
	);
};

export default Drawer;
